<template>
    <!-- Begin:Search/TabBox -->
    <div class="search-box-wrapper style1">
        <div class="search-box">
            <ul class="search-tabs clearfix">
                <!-- Begin:FlightSearchTabs-Booking ************************ -->
                <li class="active" v-if="modulo === 'booking'">
                    <a href="#flights-tab" data-toggle="tab">
                        <i class="soap-icon-plane-right takeoff-effect"></i>
                        {{ searchboxflights[getCurrentLocale] }}
                    </a>
                </li>
                <!-- <li v-if="modulo === 'booking'">
                    <a href="#packagetours-tab" data-toggle="tab">
                        <i class="soap-icon-hotel"></i>
                        {{ searchboxpackagetours[getCurrentLocale] }}
                    </a>
                </li>
                <li v-if="modulo === 'booking'">
                    <a href="#seat-tab" data-toggle="tab">
                        <i class="soap-icon-passenger"></i>
                        {{ searchboxseat[getCurrentLocale] }}
                    </a>
                </li>
                <li v-if="modulo === 'booking'">
                    <a href="#luggage-tab" data-toggle="tab">
                        <i class="soap-icon-baggage-status"></i>
                        {{ searchboxluggage[getCurrentLocale] }}
                    </a>
                </li> -->


                <!-- Begin:FlightSearchTabs-Services *********************** -->
                <!-- <li class="active" v-if="modulo === 'services'">
                    <a href="#flights-tab" data-toggle="tab">
                        <i class="soap-icon-plane-right takeoff-effect"></i>
                        {{ searchboxflights_services[getCurrentLocale] }}
                    </a>
                </li> -->
                <!-- <li v-if="modulo === 'services'">
                    <a href="#bookingno-tab" data-toggle="tab">
                        <i class="soap-icon-search"></i>
                        {{ searchboxbookingno_services[getCurrentLocale] }}
                    </a>
                </li> -->


                <!-- Begin:FlightSearchTabs-Rebooking ********************** -->
                <!-- <li class="active" v-if="modulo === 'rebooking'">
                    <a href="#rebooking-tab" data-toggle="tab">
                        <i class="soap-icon-plane-right takeoff-effect"></i>
                        {{ searchboxrebooking[getCurrentLocale] }}
                    </a>
                </li> -->


                <!-- Begin:FlightSearchTabs-Shares ************************* -->
                <!-- <li>
                    <a href="#help-tab" data-toggle="tab">
                        <i class="soap-icon-message"></i>
                        {{ searchboxhelp[getCurrentLocale] }}
                    </a>
                </li> -->
            </ul>


            <div class="visible-mobile">
                <ul id="mobile-search-tabs" class="search-tabs clearfix">
                    <!-- Begin:FlightSearchTabs-Booking ******************** -->
                    <li class="active" v-if="modulo === 'booking'">
                        <a href="#flights-tab">{{ searchboxflights[getCurrentLocale] }}</a>
                    </li>
                    <li v-if="modulo === 'booking'">
                        <a href="#packagetours-tab">{{ searchboxpackagetours[getCurrentLocale] }}</a>
                    </li>
                    <li v-if="modulo === 'booking'">
                        <a href="#seat-tab">{{ searchboxseat[getCurrentLocale] }}</a>
                    </li>
                    <li v-if="modulo === 'booking'">
                        <a href="#luggage-tab">{{ searchboxluggage[getCurrentLocale] }}</a>
                    </li>


                    <!-- Begin:FlightSearchTabs-Services ******************* -->
                    <li class="active" v-if="modulo === 'services'">
                        <a href="#flights-tab">{{ searchboxflights_services[getCurrentLocale] }}</a>
                    </li>
                    <!-- <li v-if="modulo === 'services'">
                        <a href="#bookingno-tab">{{ searchboxbookingno_services[getCurrentLocale] }}</a>
                    </li> -->


                    <!-- Begin:FlightSearchTabs-Rebooking ****************** -->
                    <li class="active" v-if="modulo === 'rebooking'">
                        <a href="#rebooking-tab">{{ searchboxrebooking[getCurrentLocale] }}</a>
                    </li>


                    <!-- Begin:FlightSearchTabs-Shares ********************* -->
                    <li>
                        <a href="#help-tab">{{ searchboxhelp[getCurrentLocale] }}</a>
                    </li>
                </ul>
            </div>


            <div class="search-tab-content">
                <!-- Begin:FlightSearchTabs-Booking ************************ -->
                <div class="tab-pane fade active in" id="flights-tab" v-if="modulo === 'booking'">
                    <sdr-shared-flightsearch-tab :modulo="modulo"></sdr-shared-flightsearch-tab>
                </div>
                <div class="tab-pane fade" id="packagetours-tab" v-if="modulo === 'booking'">
                    <sdr-shared-packagetours-tab></sdr-shared-packagetours-tab>
                </div>
                <div class="tab-pane fade" id="seat-tab" v-if="modulo === 'booking'">
                    <sdr-shared-seat-tab></sdr-shared-seat-tab>
                </div>
                <div class="tab-pane fade" id="luggage-tab" v-if="modulo === 'booking'">
                    <sdr-shared-luggage-tab></sdr-shared-luggage-tab>
                </div>


                <!-- Begin:FlightSearchTabs-Services *********************** -->
                <div class="tab-pane fade active in" id="flights-tab" v-if="modulo === 'services'">
                    <sdr-shared-flightsearch-tab :modulo="modulo"></sdr-shared-flightsearch-tab>
                </div>
                <div class="tab-pane fade" id="bookingno-tab" v-if="modulo === 'services'">
                    <sdr-shared-bookingno-tab></sdr-shared-bookingno-tab>
                </div>


                <!-- Begin:FlightSearchTabs-Rebooking ********************** -->
                <div class="tab-pane fade active in" id="rebooking-tab" v-if="modulo === 'rebooking'">
                    <sdr-shared-rebooking-tab></sdr-shared-rebooking-tab>
                </div>


                <!-- Begin:FlightSearchTabs-Shares ************************* -->
                <div class="tab-pane fade" id="help-tab">
                    <sdr-shared-help-tab></sdr-shared-help-tab>
                </div>
            </div>
        </div>
    </div>
    <!-- End:Search/TabBox -->
</template>

<script>
    import FlightSearchTab from '../../shared/flightsearch/FlightSearchTab.vue';// Tab::'FlightSearch' (shared)
    import BookingnoTab from '../../shared/forms/BookingnoTab.vue';             // Tab::'Bookingno' (Services)
    import PackageToursTab from '../../shared/forms/PackageToursTab.vue';       // Tab::'PackageTours' (Booking)
    import SeatTab from '../../shared/forms/SeatTab.vue';                       // Tab::'Seat' (Services)
    import LuggageTab from '../../shared/forms/LuggageTab.vue';                 // Tab::'Luggage' (Booking)
    import RebookingTab from '../../shared/forms/RebookingTab.vue';             // Tab::'Rebooking' (Rebooking)
    import HelpTab from '../../shared/forms/HelpTab.vue';                       // Tab::'Help' (Shared)

    import { mapGetters } from 'vuex';


    export default {

        /* >>> *************************************************************** / /* Props */
        props: ['modulo'],
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Components */
        components: {

            'sdr-shared-flightsearch-tab': FlightSearchTab,
            'sdr-shared-packagetours-tab': PackageToursTab,
            'sdr-shared-bookingno-tab': BookingnoTab,
            'sdr-shared-seat-tab': SeatTab,
            'sdr-shared-luggage-tab': LuggageTab,
            'sdr-shared-rebooking-tab': RebookingTab,
            'sdr-shared-help-tab': HelpTab,

        }, // eo components{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data: function() {

            return {
                searchboxflights: {
                    en: 'Flights',
                    de: 'Flüge',
                },
                searchboxpackagetours: {
                    en: 'Package tour',
                    de: 'Pauschalreise',
                },

                searchboxflights_services: {
                    en: 'Find your Flight',
                    de: 'Ihren Flug finden',
                },
                searchboxbookingno_services: {
                    en: 'Find your booking',
                    de: 'Ihre Buchung finden',
                },
                searchboxseat: {
                    en: 'Seats',
                    de: 'Sitzplätze',
                },
                searchboxluggage: {
                    en: 'Luggage',
                    de: 'Gepäck',
                },
                searchboxrebooking: {
                    en: 'Rebooking Flights',
                    de: 'Flüge umbuchen',
                },
                searchboxhelp: {
                    en: 'Help & Contact',
                    de: 'Hilfe & Kontakt',
                },
                // currentLocale: 'de',
            };

        }, // eo function data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'getCurrentLocale',
            ]),

        }, // eo computed{}
        /* <<< ****************************************************************/

    };
</script>








// WEBPACK FOOTER //
// src/components/shared/flightsearch/FlightSearchTabs.vue